export default __webpack_public_path__ + "static/media/slide_certificaciones.0080aeaf.png";